/**
 * HardwareProviderOrders — the seller's Orders page (left nav).
 *
 * Hardware purchased through the site by software providers: order book,
 * line detail, and the mark-shipped fulfilment action.
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isManufacturerAdmin } from '../services/users';
import { ProviderOrders } from '../components/ProviderOrders';
import {
  PageContainer,
  PageHeader,
  PageTitle,
} from '../components/styled';

function HardwareProviderOrders() {
  const { user } = useAuth();
  const manufacturerId = Number(user?.manufacturer_id);

  if (!isManufacturerAdmin(user) || !Number.isFinite(manufacturerId)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Orders</PageTitle>
      </PageHeader>
      <ProviderOrders manufacturerId={manufacturerId} linkThrough={false} />
    </PageContainer>
  );
}

export default HardwareProviderOrders;
